import { TEALIUM_SDK_WINDOW_NAME, TEALIUM_CUSTOM_EVENT } from './constants.js';

class TealiumService {
    static createInstance(sdkUrl) {
        return new TealiumService(sdkUrl);
    }
    load() {
        if (!this.tealiumSdkLoaded) {
            this.loadSdk(this.sdkUrl);
        }
    }
    loadSdk(url) {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = ()=>{
            this.tealiumSdkLoaded = true;
        };
        script.onerror = ()=>console.error(`Failed to load script ${url}`)
        ;
        // Ensure script is added at the top of the body
        document.body.insertBefore(script, document.body.firstChild);
        this.tealiumScript = script;
    }
    get tealiumArray() {
        if (!globalThis.window[TEALIUM_SDK_WINDOW_NAME]) {
            globalThis.window[TEALIUM_SDK_WINDOW_NAME] = [];
        }
        return globalThis.window[TEALIUM_SDK_WINDOW_NAME];
    }
    handleEvent(event) {
        const { detail  } = event;
        this.tealiumArray.push(detail);
    }
    listen() {
        const handle = this.handleEvent.bind(this);
        globalThis.addEventListener(TEALIUM_CUSTOM_EVENT, handle);
        return ()=>{
            globalThis.removeEventListener(TEALIUM_CUSTOM_EVENT, handle);
        };
    }
    teardown() {
        if (this.tealiumScript) {
            if (this.tealiumScript.parentNode) {
                this.tealiumScript.parentNode.removeChild(this.tealiumScript);
                this.tealiumScript = null;
            }
            this.tealiumSdkLoaded = false;
        }
    }
    constructor(sdkUrl){
        this.tealiumSdkLoaded = false;
        this.tealiumScript = null;
        this.sdkUrl = sdkUrl;
    }
}

export { TealiumService };
//# sourceMappingURL=service.js.map
